import api from './api';
import {mapUserDto} from "../dto/UserDTO";

export const getAllUsers = async () => {
    try {
        const res = await api.get('/User');
        return res.data.map(mapUserDto);
    } catch (err) {
        console.error("Error receiving user:", err);
        throw err;
    }
};

export const deleteUser = async (user_id) => {
    try {
        const res = await api.delete(`/User/${user_id}`);
        return res.data;
    } catch (err) {
        console.error("Error deleting user:", err);
        throw err;
    }
}

export const changePassword = async (userId, newPassword) => {
    try {
        const res = await api.patch(`/User/${userId}/password`, {passwordClear: newPassword});
        return res.data;
    } catch (err) {
        console.error("Error deleting user:", err);
        throw err;
    }
};

export const addUser = async ({username, name, passwordClear, role}) => {
    try {
        const res = await api.post('/user', {username, name, passwordClear, role});
        return res.data;
    } catch (err) {
        console.error("Error creating user:", err);
        throw err;
    }
};

export const getProjectsForUser = async ({userId}) => {
    try {
        const res = await api.get(`/user/${userId}/projects`);
        return res.data;
    } catch (err) {
        console.error("Error get projects for user:", err);
        throw err;
    }
};